export default __webpack_public_path__ + "static/media/calendar_outline.2d5b101c.svg";